import {Component} from '@angular/core';
import {NavController, NavParams, ModalController, PopoverController, ViewController} from 'ionic-angular';
import {MenuService} from "../../app/services/menu.service";
import {Menu} from "../../app/classes/menu";
import {Product} from "../../app/classes/product";
import {CartService} from "../../app/services/cart.service";
import {Cart} from "../../app/classes/cart";
import {ProductOptionPage} from "../product-option/product-option";
import {UserService} from "../../app/services/user.service";
import {SafeHtml} from "../../app/pipes/trust";
import {ProductSizePage} from "../product-size/product-size";
import {ProductMeta} from "../../app/classes/product_meta";
import {ProductVariationPage} from "../product-variation/product-variation";
import { Dialog } from '@capacitor/dialog';
import {ProductSpecialPage} from "../product-special/product-special";
/*
 Generated class for the Menuview page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-menuview',
  templateUrl: 'menuview.html',
  providers: [MenuService, CartService, UserService, SafeHtml]
})
export class MenuViewPage {
  public menu: Menu;
  public products: Product[] = [];
  public favorites: Product[] = [];
  public errorMessage: any;
  public cart: Cart;
  public isLoading: boolean = false;
  public searchQuery: string = "";
  public hasError : boolean = false;

  constructor(public viewCtrl: ViewController, public popoverCtrl: PopoverController, public cartService: CartService, public modalCtrl: ModalController, public userService: UserService, private menuService: MenuService, public navCtrl: NavController, public navParams: NavParams) {
    this.menu = navParams.get('menu') as Menu;
    this.isLoading = true;
    this.userService.getFavorites().then((favorites) => {
      this.favorites = favorites;
    });

    this.cart = cartService.getCart();
    menuService.getProducts(navParams.get('menu') as Menu)
      .subscribe(
        products => this.setProducts(products),
        error => this.handleError(<any>error)
      );
  }

  handleError(error) {
    this.errorMessage = <any>error;
    this.isLoading = false;
    console.trace(error);
    Dialog.alert({
      message: "Fehler beim Abrufen der Produkte, bitte versuchen Sie es später noch einmal",
      title: "Fehler"
    }).then(() => {
      this.viewCtrl.dismiss();
    });
  }

  setProducts(products) {
    this.products = products.map(product => {
      product.searchMask = `${product.name}|${product.description}|${product.number}`
      return product;
    });
    this.isLoading = false;
  }

  isFavorite(product: Product) {
    let result = false;
    this.favorites.forEach((favorite) => {
      if (favorite.id == product.id) {
        result = true;
      }
    });
    return result;
  }

  favoriteProduct(product: Product) {
    this.userService.addFavorite(product);
    this.favorites.push(product);
  }

  unfavoriteProduct(product: Product) {
    this.userService.removeFavorite(product);
    this.favorites = this.favorites.filter((f) => {
      return f.number !== product.number;
    });
  }

  filterItems(event: Event) {

  }


  async addProductToCart(product: Product) {
    // make a copy
    product = new Product(product.getPayload(), product.getCategory());

    // check for variations
    if (product.variations.length > 0){
      let popover = this.popoverCtrl.create(ProductVariationPage, {
        variations: product.variations
      });

      popover.onDidDismiss((result) => {
        if (result !== false) {
          product.setVariation(product.variations[result], result);

          if (product.prices.length == 1) {
            product.setMeta(product.prices[0], 0);
            this.cart.addProduct(product, {
              added: [],
              removed: []
            });
          } else {
            let popover = this.popoverCtrl.create(ProductSizePage, {sizes: product.prices});
            popover.onDidDismiss((result) => {
              if (result !== false) {
                product.setMeta(product.prices[result], result);
                this.cart.addProduct(product, {
                  added: [],
                  removed: []
                });
              }
            });
            popover.present();
          }
        }
      });
      popover.present();
    }
    else if (product.prices.length == 1) {
      product.setMeta(product.prices[0], 0);
      this.cart.addProduct(product, {
        added: [],
        removed: []
      });
    } else {
      let popover = this.popoverCtrl.create(ProductSizePage, {sizes: product.prices});
      popover.onDidDismiss((result) => {
        if (result !== false) {
          console.log(product.prices, result)
          product.setMeta(product.prices[result], result);
          this.cart.addProduct(product, {
            added: [],
            removed: []
          });
        }
      });
      popover.present();
    }

  }


  async selectProductSpecial(product: Product) {
    // make a copy
    product = new Product(product.getPayload(), product.getCategory());

    const modal = this.modalCtrl.create(ProductSpecialPage, {product});
    modal.present();
  }

  showOptions(product: Product) {
    const modal = this.modalCtrl.create(ProductOptionPage, {product})
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/menuview/menuview.ts